/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceAccountSyncStatusPropagation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceAccountSyncStatusPropagation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceAccountSyncStatusPropagation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceAccountSyncStatusPropagation>): BackgroundJobPayloadForServiceAccountSyncStatusPropagation {
        let obj = Object.assign(new BackgroundJobPayloadForServiceAccountSyncStatusPropagation(), model);
        BackgroundJobPayloadForServiceAccountSyncStatusPropagation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceAccountSyncStatusPropagation>): BackgroundJobPayloadForServiceAccountSyncStatusPropagation {
        if (!model) return null;
        return BackgroundJobPayloadForServiceAccountSyncStatusPropagation.newInstance(<BackgroundJobPayloadForServiceAccountSyncStatusPropagation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceAccountSyncStatusPropagation) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceAccountSyncStatusPropagation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceAccountSyncStatusPropagation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceAccountSyncStatusPropagation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * The item to trigger
     */
    field: string;

}
